"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/TextMessage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);












var _RichMessageWrapper = require('./RichMessageWrapper'); var _RichMessageWrapper2 = _interopRequireDefault(_RichMessageWrapper);
var _ReplyQuoteBlock = require('./ReplyQuoteBlock'); var _ReplyQuoteBlock2 = _interopRequireDefault(_ReplyQuoteBlock);
var _SaveAsTemplateHost = require('web/components/MessageTemplates/SaveAsTemplateHost');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _ui = require('web/services/ui');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');
var _Linkify = require('shared/components/Linkify'); var _Linkify2 = _interopRequireDefault(_Linkify);
var _mentions = require('shared/services/mentions');
var _templateFromMessage = require('shared/services/templateFromMessage');









var _translation = require('shared/selectors/translation');
var _TranslationLabel = require('./TranslationLabel');
var _SpamBadge = require('./SpamBadge'); var _SpamBadge2 = _interopRequireDefault(_SpamBadge);
var _TranslationOffDialog = require('../TranslationOffDialog'); var _TranslationOffDialog2 = _interopRequireDefault(_TranslationOffDialog);





const NonLinkText = ({ children }) => _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, children)







const Link = ({ children, url, type }) => (
  _react2.default.createElement('a', { href: url, rel: "noreferrer", target: type === 'url' ? '_blank' : '_self', __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
    ,  children 
  )
)















































const mentionsUser = (currentUserKey, subscribers) => {
  const currentSubscriber = _optionalChain([subscribers, 'optionalAccess', _ => _[currentUserKey]])
  return (mention) => !!mention && (
    mention.Kind === 'all' || mention.TargetKey === currentUserKey ||
    (mention.Kind === 'team' && !!('Teams' in (currentSubscriber || {}) && _optionalChain([(currentSubscriber ), 'access', _2 => _2.Teams, 'optionalAccess', _3 => _3[mention.TargetKey || '']])))
  )
}








/* A message's text, with its mentions and links. Also captions a file. */
 const MessageBody = ({ text, mentions, currentUserKey, subscribers }) => {
  const isMentionForMe = mentionsUser(currentUserKey, subscribers)
  return (
    _react2.default.createElement('div', { className: "text-message--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
      , _mentions.splitTextWithMentions.call(void 0, text, mentions).map(segment => segment.mention ? (
        _react2.default.createElement('span', {
          key: segment.start,
          className: _classBuilder2.default.call(void 0, 'message-mention', {
            'message-mention--self': isMentionForMe(segment.mention),
          }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
, segment.text)
      ) : (
        _react2.default.createElement(_Linkify2.default, {
          key: segment.start,
          useMemo: _react.useMemo,
          text: segment.text,
          LinkComponent: Link,
          TextComponent: NonLinkText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
        )
      ))
    )
  )
}; exports.MessageBody = MessageBody

const TextMessage = ({
  text, onRetry, mentions, replyToMessageKey, replyPreview,
  translation, delivered, deliveries, spamBand, showTranslations = false, attachment, ...baseMessageProps
}) => {
  const {
    deleted, senderKey, currentUserKey, messageKey, subscribers, conversationKey, senderName, senderType, onJumpToMessage,
  } = baseMessageProps
  const openSaveAsTemplate = _SaveAsTemplateHost.useOpenSaveAsTemplate.call(void 0, )
  const isFromOtherUser = senderKey !== currentUserKey
  const isMentionForMe = mentionsUser(currentUserKey, subscribers)

  const className = _classBuilder2.default.call(void 0, 
    "text-message", {
      "text-message--me": !isFromOtherUser,
      "text-message--them": isFromOtherUser,
      "text-message--mentions-me": isFromOtherUser && _optionalChain([mentions, 'optionalAccess', _4 => _4.some, 'call', _5 => _5(isMentionForMe)]),
    },
  )

  const isFromPatient = senderType === 'patient'
  // A household reply names each patient; the chat's state (one reference
  // until it changes) supplies their languages for the shared-phone hint.
  const hasDeliveries = !deleted && !isFromPatient && showTranslations && !!_optionalChain([deliveries, 'optionalAccess', _6 => _6.length])
  const chatTranslation = _hooks.useAppSelector.call(void 0, state => hasDeliveries
    ? _translation.selectConversationTranslation.call(void 0, state, conversationKey)
    : undefined)
  // Memoized so the label rows get the same display object until the
  // message or the chat's display setting changes.
  const inboundDisplay = _react.useMemo.call(void 0, () => !deleted && isFromPatient
    ? _translation.getInboundTranslationDisplay.call(void 0, { Translation: translation }, showTranslations)
    : null, [deleted, isFromPatient, translation, showTranslations])
  const deliveredDisplay = _react.useMemo.call(void 0, () => !deleted && !isFromPatient
    ? _translation.getDeliveredDisplay.call(void 0, 
      { Delivered: delivered, Deliveries: deliveries },
      showTranslations,
      chatTranslation ? _translation.getChatPatients.call(void 0, chatTranslation) : undefined,
    )
    : null, [deleted, isFromPatient, delivered, deliveries, showTranslations, chatTranslation])
  const showSpamBadge = !deleted && _translation.isSuspectedSpam.call(void 0, { SenderType: senderType, SpamBand: spamBand })

  const originalText = deleted ? '' : text
  // A translated patient message shows the English; the original is one
  // click away under it. Mentions index the original, so they're dropped.
  const msgText = _optionalChain([inboundDisplay, 'optionalAccess', _7 => _7.kind]) === 'translated' ? inboundDisplay.text : originalText
  const msgMentions = _optionalChain([inboundDisplay, 'optionalAccess', _8 => _8.kind]) === 'translated' ? undefined : mentions

  const handleCopy = _react.useCallback.call(void 0, () => _ui.copyToClipboard.call(void 0, msgText), [msgText])
  const handleRetry = _react.useCallback.call(void 0, 
    () => onRetry(messageKey, msgText, mentions),
    [messageKey, msgText, mentions, onRetry],
  )
  const handleSaveAsTemplate = _react.useCallback.call(void 0, 
    () => _optionalChain([openSaveAsTemplate, 'optionalCall', _9 => _9({ text: msgText, conversationKey, senderName: _templateFromMessage.staffNameForMessage.call(void 0, senderType, senderName) })]),
    [openSaveAsTemplate, msgText, conversationKey, senderName, senderType],
  )

  // Translate in the options menu (the pill's command, for this message).
  // Only patient rows read the chat's state, as a boolean, so a translation
  // change re-renders just the rows whose answer flips.
  const canTranslate = _hooks.useAppSelector.call(void 0, state => isFromPatient && !deleted && _translation.canTranslateFromMessage.call(void 0, 
    { SenderType: senderType, MessageType: 'text', Deleted: deleted, MessageText: text, Translation: translation },
    _translation.selectConversationTranslation.call(void 0, state, conversationKey),
  ))
  const translating = _hooks.useAppSelector.call(void 0, state => canTranslate && _translation.selectIsTranslatingFromMessage.call(void 0, state, conversationKey))
  // With the org's translation off, Translate explains that instead of
  // sending anything.
  const isOrgOff = _hooks.useAppSelector.call(void 0, state => canTranslate &&
    _translation.isTranslationOffForOrg.call(void 0, _translation.selectConversationTranslation.call(void 0, state, conversationKey)))
  const [isOrgOffDialogOpen, setIsOrgOffDialogOpen] = _react.useState.call(void 0, false)
  const closeOrgOffDialog = _react.useCallback.call(void 0, () => setIsOrgOffDialogOpen(false), [])
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const handleTranslate = _react.useCallback.call(void 0, () => {
    if (isOrgOff) {
      setIsOrgOffDialogOpen(true)
      return
    }
    // Resolves to the notice to show, or null once translation is on.
    _actions2.default.translateFromMessage({ ConversationKey: conversationKey, MessageKey: messageKey })
      .then((notice) => {
        if (notice) showWarningBar(notice)
      })
  }, [isOrgOff, conversationKey, messageKey, showWarningBar])

  const msgProps = {
    ...baseMessageProps,
    onCopy: deleted ? null : handleCopy,
    onTranslate: canTranslate ? handleTranslate : null,
    translating,
    onSaveAsTemplate: deleted || !openSaveAsTemplate ? null : handleSaveAsTemplate,
  }

  // The quote sits inside the bubble, above the reply (Round 3); file rows
  // keep it above the file, where RichMessageWrapper puts it.
  const quote = replyToMessageKey && onJumpToMessage
    ? (
        _react2.default.createElement(_ReplyQuoteBlock2.default, {
          conversationKey: conversationKey,
          replyToMessageKey: replyToMessageKey,
          replyPreview: replyPreview,
          onJumpToMessage: onJumpToMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
        )
      )
    : null

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_RichMessageWrapper2.default, { ...msgProps, onRetry: handleRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}
        ,  (!attachment || deleted || msgText || quote) && _react2.default.createElement('div', { className: className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}}
          ,  deleted
            ? _react2.default.createElement('div', { className: "message--deleted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}},  quote , "This message was recalled"   )
            : _react2.default.createElement('div', { className: "text-message--content", dir: "auto", __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}
                ,  quote 
                , _mentions.splitTextWithMentions.call(void 0, msgText, msgMentions).map(segment => segment.mention ? (
                  _react2.default.createElement('span', {
                    key: segment.start,
                    className: _classBuilder2.default.call(void 0, 'message-mention', {
                      'message-mention--self': isMentionForMe(segment.mention),
                    }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
, segment.text)
                ) : (
                  _react2.default.createElement(_Linkify2.default, {
                    key: segment.start,
                    useMemo: _react.useMemo,
                    text: segment.text,
                    LinkComponent: Link,
                    TextComponent: NonLinkText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 263}}
                  )
                ))
              )
          
        ) 
        ,  !deleted && attachment 
        , _react2.default.createElement(_TranslationLabel.InboundTranslationLabel, { display: inboundDisplay, originalText: originalText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}} )
        , _react2.default.createElement(_TranslationLabel.DeliveredLabel, { display: deliveredDisplay, alignRight: !isFromOtherUser, __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}} )
        /* SAFETY: showSpamBadge implies a patient message, whose sender is a PatientKey. */
        ,  showSpamBadge && (
          _react2.default.createElement(_SpamBadge2.default, { patientKey: senderKey , __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}} )
        )
      )
      /* Outside the row, so its clicks don't reach the row's handlers. */
      ,  isOrgOffDialogOpen && (
        _react2.default.createElement(_TranslationOffDialog2.default, { conversationKey: conversationKey, isOpen: true, onClose: closeOrgOffDialog, __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}} )
      )
    )
  )
}

exports. default = TextMessage
